export default function Scenario() {
  const steps = [
    {
      time: 'Evening',
      icon: 'ri-mail-send-line',
      title: 'A homeowner requests a quote in the evening',
      color: 'bg-teal-100 text-teal-700'
    },
    {
      time: 'Instant',
      icon: 'ri-flashlight-line',
      title: 'Instant reply confirms availability',
      color: 'bg-cyan-100 text-cyan-700'
    },
    {
      time: 'Next Morning',
      icon: 'ri-refresh-line',
      title: 'Next morning follow-up sent automatically',
      color: 'bg-emerald-100 text-emerald-700'
    },
    {
      time: 'Result',
      icon: 'ri-checkbox-circle-line',
      title: 'You open your dashboard to a ready-to-book job',
      color: 'bg-green-100 text-green-700'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-gray-50 to-teal-50">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 text-center mb-16">
          What This Looks Like In Real Life
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, index) => (
            <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className={`w-16 h-16 ${step.color} rounded-full flex items-center justify-center mb-6`}>
                <i className={`${step.icon} text-3xl`}></i>
              </div>
              
              <div className="text-sm font-semibold text-teal-600 mb-3">
                {step.time}
              </div>
              
              <p className="text-gray-800 leading-relaxed">
                {step.title}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
